module.exports = __webpack_public_path__ + "img/Aparat.b9dd4856.png";